export default "__VITE_ASSET__U9JQcwF0__"